import { Dispatch } from 'react';
import { TMaintenancePackageActionTypes } from '../types';
import { SET_LOADING } from 'src/contexts/types';
import { handleError } from 'src/contexts/utils/handleError';
import { HEADERS } from 'src/constants/headers';
import { ApiV2 } from 'src/api/apiv2';
import { DELETE_MAINTENANCE_PACKAGE } from '../constants';
import { TBulkDeleteFilter } from 'src/interfaces/TBulkDeleteFilter';

export const bulkDeleteMaintenancePackages = async (
    dispatch: Dispatch<TMaintenancePackageActionTypes>,
    values: TBulkDeleteFilter,
    callback: Function
) => {
    dispatch({ type: SET_LOADING });

    try {
        await ApiV2.post(
            `/maintenance-packages/bulk-delete`,
            { ...values },
            HEADERS({
                isReadPermissionNecessary: false,
            })
        );

        dispatch({ type: DELETE_MAINTENANCE_PACKAGE, payload: null });

        if (callback) callback();
    } catch (error) {
        if (error instanceof Error) dispatch(handleError(error));
    }
};
